import React from 'react';
import { paginationDefaultValues } from './constants';
import { PaginationDefaultValue } from './types';
export const usePagination = (limit) => {
    const [page, setPage] = React.useState(0);
    const [perPage, setPerPage] = React.useState(limit ? paginationDefaultValues[limit] : paginationDefaultValues[PaginationDefaultValue.LG]);
    return React.useMemo(() => ({
        page,
        setPage,
        perPage,
        setPerPage,
    }), [page, perPage]);
};
